import React from 'react'
import { Popover } from 'antd'

import type { TListItem } from '@/contexts/PlanContext/hooks/productText'

import { CssIcon } from '@/components/CssIcon'


import { tw, cls } from 'tagged-classnames-free';
export interface IListItemProps {
  className?: string
  textList: TListItem[]
  liClassName?: (enable: boolean) => string
  iconContainerClassName?: string
  iconClassName?: string
  onItemClick?: () => void
}

const ListItem: React.FC<IListItemProps> = (props) => {
  const {
    className,
    textList,
    liClassName,
    iconClassName,
    iconContainerClassName,
    onItemClick,
  } = props
  return (
    <ul
      className={tw`
        ${className}
      `}
    >
      {textList.map((text, index) => {
        const _key = index
        const showIcon =
          typeof text?.showIcon === 'boolean' ? text.showIcon : true
        return (
          <li
            key={_key}
            className={tw`
              mb-2 flex
              items-center space-x-1
              text-start
              text-xs last:mb-0
              ${liClassName?.(text.enabled)}
            `}
            onClick={onItemClick}
          >
            {showIcon && (
              <CssIcon
                containerClassName={cls`
                  flex items-center justify-center
                  ${iconContainerClassName}
                `}
                className={tw`
                  ${text.enabled ? 'i-bx--check text-f-success' : 'i-com--x'}
                    size-4
                   ${iconClassName}
                `}
              />
            )}
            <div className='flex min-w-0 flex-1 items-start gap-1'>
              <span className='min-w-0'>{text.label}</span>
              {text.tooltipContent ? (
                <Popover
                  trigger={['hover', 'click']}
                  placement='top'
                  content={text.tooltipContent}
                  arrow={false}
                >
                  <button
                    type='button'
                    className='text-f-text-quaternary mt-px inline-flex size-3.5 flex-none cursor-pointer items-center justify-center'
                    aria-label='View details'
                    onClick={(event) => event.stopPropagation()}
                  >
                    <span className='i-cus--tad-info-circle-linear size-3.5' />
                  </button>
                </Popover>
              ) : null}
            </div>
          </li>
        )
      })}
    </ul>
  )
}

export default ListItem
